import Source from "./From/Source";
import Customer from "./To/Customer";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import classNames from "classnames";
import Buttons from "./Buttons";
import List from './List';
import isEqual from "lodash-es/isEqual";
import connect from "react-redux/es/connect/connect";
import Box from "../../../layout/Box";
import Shipping from "./Shipping";
import AccountDate from "./Invoice/Dates/AccountDate";
import DateTimeInput from "../../../form/DateTimeInput";
import moment from "moment";

class ConsignmentReturnForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        if (!((this.props.till || {}).pos || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-4">
                                <Source {...componentProps} />
                            </div>
                            <div className="col-md-4">
                                <Customer {...componentProps} />
                            </div>
                            <AccountDate
                                col="4"
                                {...componentProps}
                                isClearable={true}
                            />
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <div className="row form-row">
                            <div className="col-md-6">
                                <DateTimeInput
                                    minDate={moment().subtract(1, "years").format("YYYY-MM-DD")}
                                    maxDate={(props.values.xtradata || {}).enddate}
                                    value={(props.values.xtradata || {}).startdate}
                                    label="Fogyás időszak"
                                    isClearable={true}
                                    saveChanges={(field, startdate) => props.setFieldValue("xtradata.startdate", startdate)}
                                />
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <DateTimeInput
                                        minDate={(props.values.xtradata || {}).startdate}
                                        value={(props.values.xtradata || {}).enddate}
                                        label="&nbsp;"
                                        isClearable={true}
                                        saveChanges={(field, enddate) => props.setFieldValue("xtradata.enddate", enddate)}
                                    />
                                </div>
                            </div>
                        </div>
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}


export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(ConsignmentReturnForm);